module.exports = __webpack_public_path__ + "static/media/illustration-accueil.5ebe1a0a.png";